const HomePageLinguals = {
  languageOfferTitle: 'I want to speak',
}

export default HomePageLinguals
